import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { AppState } from 'app/app-state';
import ThemeProvider from 'app/common/utils/theme-provider';
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import type { Store } from 'redux';
import Router from './router';

export type RootProps = {
  readonly store: Store<AppState>;
};

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

class Root extends React.Component<RootProps> {
  override render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ThemeProvider>
            {/* @ts-expect-error DnDProvider children */}
            <DndProvider backend={HTML5Backend}>
              <QueryClientProvider client={client}>
                <Router />
              </QueryClientProvider>
            </DndProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </Provider>
    );
  }
}

export default Root;
